import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Explainers.css';

const Explainers = () => {
  return (
    <>
      <Helmet>
        <title>Explainers - Business Concepts Made Simple | Redbox Global</title>
        <meta name="description" content="Redbox Global Explainers break down complex business topics, economic concepts, and financial terms into easy-to-understand guides. Learn the fundamentals that drive markets." />
        <meta name="keywords" content="business explainers, financial education, economic concepts, business guides, financial literacy, market education, business fundamentals, explained" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/explainers" />
        <meta property="og:title" content="Explainers - Business Concepts Made Simple | Redbox Global" />
        <meta property="og:description" content="Break down complex business topics and financial concepts into easy-to-understand guides." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/explainers" />
        <meta name="twitter:title" content="Explainers - Business Concepts Made Simple | Redbox Global" />
        <meta name="twitter:description" content="Break down complex business topics and financial concepts into easy-to-understand guides." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/explainers" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Explainers</h1>
          <p className="page-subtitle">Complex business concepts made simple and accessible</p>
        </div>
        
        <div className="page-content">
          <a href="/article/cryptocurrency-explained" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1200&h=600&fit=crop" alt="Learning concept" />
              </div>
              <div className="featured-content">
                
                <h2>Cryptocurrency Explained: A Complete Beginner's Guide</h2>
                <p>From Bitcoin to blockchain, understand the fundamentals of digital currencies without the technical jargon. This comprehensive guide covers how cryptocurrencies work, why they matter, the technology behind them, and what you need to know about investing. Perfect for anyone wanting to understand this revolutionary asset class.</p>
                <span className="article-meta">8 min read • Updated February 2026</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/fed-interest-rates-explained" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Federal Reserve" />
                </div>
                <div className="article-content">
                 
                  <h2>How the Federal Reserve Sets Interest Rates</h2>
                  <p>Demystifying the Fed's decision-making process and what it means for your finances.</p>
                  <span className="article-meta">6 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/stock-market-basics" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" alt="Stock market" />
                </div>
                <div className="article-content">
                 
                  <h2>Stock Market Basics: How Exchanges Actually Work</h2>
                  <p>Understanding the mechanics of buying and selling stocks in modern markets.</p>
                  <span className="article-meta">7 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/supply-chain-explained" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop" alt="Supply chain" />
                </div>
                <div className="article-content">
                
                  <h2>Global Supply Chains: From Factory to Your Door</h2>
                  <p>Breaking down the complex network that delivers products around the world.</p>
                  <span className="article-meta">9 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Explainers;
